export const mockChats = [
  {
    id: 1,
    protocol: 'PROTO-00123',
    name: 'Suporte Técnico',
    status: 'open',
    avatarUrl: 'https://i.pravatar.cc/150?img=1',
    unreadCount: 2, // Aumentado para refletir novas mensagens
    messages: [
      { id: 1, text: 'Olá! Como posso ajudar?', sender: 'Suporte', timestamp: '2025-10-06T10:30:00Z' },
      { id: 2, text: 'Estou com um problema na minha impressora.', sender: 'me', timestamp: '2025-10-06T10:31:00Z' },
      { id: 3, text: 'Ela não está ligando.', sender: 'me', timestamp: '2025-10-06T10:31:20Z' }, // Mensagem agrupada
      { id: 4, text: 'Ok, vamos verificar alguns passos.', sender: 'Suporte', timestamp: '2025-10-06T10:32:00Z' },
    ],
  },
  {
    id: 2,
    protocol: 'PROTO-00124',
    name: 'Joana Silva (Franquia)',
    status: 'open',
    avatarUrl: 'https://i.pravatar.cc/150?img=2',
    unreadCount: 0,
    messages: [
      { id: 1, text: 'Oi, tudo bem?', sender: 'Joana Silva', timestamp: '2025-10-06T11:05:00Z' },
    ],
  },
  {
    id: 3,
    protocol: 'PROTO-00105',
    name: 'Financeiro',
    status: 'closed',
    avatarUrl: 'https://i.pravatar.cc/150?img=3',
    unreadCount: 0,
    messages: [
      { id: 1, text: 'Sua fatura foi paga.', sender: 'Financeiro', timestamp: '2025-10-05T15:00:00Z' },
      { id: 2, text: 'Obrigado!', sender: 'me', timestamp: '2025-10-05T15:01:00Z' },
    ],
  },
];